export default {
  blank: () => import("/builds/nextory/web/nx-web/layouts/blank.vue"),
  "cancellation-flow": () => import("/builds/nextory/web/nx-web/layouts/cancellation-flow.vue"),
  catalog: () => import("/builds/nextory/web/nx-web/layouts/catalog.vue"),
  default: () => import("/builds/nextory/web/nx-web/layouts/default.vue"),
  "header-menu": () => import("/builds/nextory/web/nx-web/layouts/headerMenu.vue"),
  login: () => import("/builds/nextory/web/nx-web/layouts/login.vue"),
  "transparent-header": () => import("/builds/nextory/web/nx-web/layouts/transparent-header.vue"),
  user: () => import("/builds/nextory/web/nx-web/layouts/user.vue")
}